// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__KI8xt","navBar":"styles_navBar__1hIT8"};